/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceTypeCertificateEtcResponse,
    DeviceTypeCertificateEtcResponseFromJSON,
    DeviceTypeCertificateEtcResponseFromJSONTyped,
    DeviceTypeCertificateEtcResponseToJSON,
} from './DeviceTypeCertificateEtcResponse';

/**
 * 
 * @export
 * @interface DeviceTypeCertificateResponse
 */
export interface DeviceTypeCertificateResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeCertificateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeCertificateResponse
     */
    deviceTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeCertificateResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeCertificateResponse
     */
    data: string;
    /**
     * 
     * @type {DeviceTypeCertificateEtcResponse}
     * @memberof DeviceTypeCertificateResponse
     */
    etc: DeviceTypeCertificateEtcResponse;
}

export function DeviceTypeCertificateResponseFromJSON(json: any): DeviceTypeCertificateResponse {
    return DeviceTypeCertificateResponseFromJSONTyped(json, false);
}

export function DeviceTypeCertificateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeCertificateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deviceTypeId': json['deviceTypeId'],
        'name': json['name'],
        'data': json['data'],
        'etc': DeviceTypeCertificateEtcResponseFromJSON(json['etc']),
    };
}

export function DeviceTypeCertificateResponseToJSON(value?: DeviceTypeCertificateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deviceTypeId': value.deviceTypeId,
        'name': value.name,
        'data': value.data,
        'etc': DeviceTypeCertificateEtcResponseToJSON(value.etc),
    };
}

